// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__MO8oF","checkboxCol":"Table_checkboxCol__10P2a","emailCol":"Table_emailCol__3CdD_","actionCol":"Table_actionCol__2AOTL"};